module.exports = __webpack_public_path__ + "static/img/BT.bb4638c2.svg";